import Swiper, {EffectFade, Autoplay} from 'swiper';

import {Component} from '@lib/Component';
import {MediaQuery} from '@services/MediaQuery';

export class ImageSwiper extends Component {
  swiper: Swiper | null = null;
  pagination: HTMLDivElement[] = [];
  mq: MediaQuery | null = null;

  constructor() {
    super();
    this.mq = MediaQuery.create();
  }

  didMount() {
    if (this.element) {
      const slides = [
        ...this.element.querySelectorAll('.swiper-slide'),
      ] as HTMLDivElement[];
      const hasImages = slides.length > 1;
      this.swiper = new Swiper(this.element, {
        allowTouchMove: hasImages,
        autoHeight: true,
        autoplay: hasImages
          ? {
              delay: 2500,
              disableOnInteraction: false,
            }
          : false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        modules: [EffectFade, Autoplay],
      });
    }
  }

  didUnmount() {
    // TODO: remove event listener
    this.swiper?.destroy();
  }
}
